export default __webpack_public_path__ + "static/logo-sctec-light-e7058be9ea7d3e32893af65efce879af.png";